import { Button, useMediaQuery, useTheme } from "@mui/material";
import { capitalizeFirstLetter } from "@/utils/capitalizeFirstLetter";
// import {
//   addProductToCart,
//   updateProductQuantity,
// } from "@/redux-store/cart/cartSlice";
// import { selectCart } from "@/redux-store/cart";
// import { togglePopUp } from "@/redux-store/cartPopUp/cartPopUpSlice";
// import subscription_imageUrl from "@/assets/images/subscription-img.png";
// import { useAppDispatch, useAppSelector } from "@/redux-store/hooks";
import { ROUTES } from "@/utils/navigation";
import { Link } from "react-router-dom";

interface IProps {
  plan: IPlan;
}

export const PricingButton: React.FC<IProps> = ({ plan }) => {
  const { mostPopular, name } = plan;
  const theme = useTheme();
  const isTablet = useMediaQuery(
    "(min-width: 1024px) and (max-width: 1199.98px)"
  );

  // const cartStoredData = useAppSelector(selectCart);
  // const dispatch = useAppDispatch();

  // const addPlanToCart = () => {
  //   // Find if product is already in a Cart
  //   const index = cartStoredData.findIndex((item) => item.id === id);
  //
  //   // if subscription has not been added yet, add it to Cart,
  //   // otherwise - update quantity
  //   if (index === -1) {
  //     const productData: ICartProduct = {
  //       id,
  //       quantity: 1,
  //       type: "plan",
  //       title: plan.name,
  //       price: yearlyPrice,
  //       oldPrice: null,
  //       image: subscription_imageUrl,
  //     };
  //
  //     dispatch(addProductToCart(productData));
  //   } else {
  //     dispatch(
  //       updateProductQuantity({
  //         id,
  //         quantity: cartStoredData[index].quantity + 1,
  //         title: name,
  //         price: yearlyPrice,
  //         oldPrice: null,
  //         image: subscription_imageUrl,
  //       })
  //     );
  //   }
  //
  //   // Open cart pop-up
  //   dispatch(togglePopUp());
  // };

  return (
    <Button
      to={ROUTES.legacySignUp}
      component={Link}
      variant={mostPopular ? "contained" : "outlined"}
      color="primary"
      fullWidth
        onClick={() => {}}
      sx={{
        fontSize: isTablet ? 14 : 16,
        marginBottom: 2,
        backgroundColor: `${!mostPopular ? `transparent !important` : ""}`,
        color: `${!mostPopular ? `${theme.palette.grey[800]} !important` : ""}`,
      }}
    >
      {capitalizeFirstLetter("choose")} {name.toUpperCase()}
    </Button>
  );
};
